/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcDtccDtcV1AssetDayState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_DTCC_DTC_V1_ASSET_DAY_STATE_ENTITY_NAME = 'ixc.dtcc.dtc.v1.AssetDay';
export const ixcDtccDtcV1AssetDayStateEntity = new schema.Entity<IxcDtccDtcV1AssetDayState>(IXC_DTCC_DTC_V1_ASSET_DAY_STATE_ENTITY_NAME, {}, { idAttribute: (entity: IxcDtccDtcV1AssetDayState) => `${entity.assetId}-${entity.date}` });

